// src/components/HelpPdfModal.jsx
// 機能画面ごとの説明PDFを画面内モーダルで表示する（PDF.js を使うため iPhone でも描画できる）。
import React, { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "./HelpPdfModal.css";

// CRA では public/ に置いた worker を参照するのが最も確実
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

export default function HelpPdfModal({ title, url, onClose, onDisable }) {
  const [numPages, setNumPages] = useState(0);
  const [error, setError] = useState("");
  const [width, setWidth] = useState(0);
  const bodyRef = useRef(null);

  // スマホ幅に合わせてPDFを収める
  useEffect(() => {
    const measure = () => {
      const w = bodyRef.current?.clientWidth || 0;
      setWidth(Math.max(0, w - 16));
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  // 背景スクロールを止める
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, []);

  return (
    <div className="help-modal-backdrop" role="dialog" aria-modal="true" aria-label={title}>
      <div className="help-modal">
        <div className="help-modal-header">
          <span className="help-modal-title">{title}</span>
          <button type="button" className="help-modal-close" onClick={onClose} aria-label="閉じる">×</button>
        </div>

        <div className="help-modal-body" ref={bodyRef}>
          {error ? (
            <div className="help-modal-error">
              <p>説明の読み込みに失敗しました。</p>
              <a href={url} target="_blank" rel="noopener noreferrer">PDFを別タブで開く</a>
            </div>
          ) : (
            <Document
              file={url}
              onLoadSuccess={({ numPages: n }) => setNumPages(n)}
              onLoadError={() => setError("load")}
              loading={<div className="help-modal-loading">読み込み中…</div>}
            >
              {Array.from({ length: numPages }, (_, i) => (
                <Page
                  key={i}
                  pageNumber={i + 1}
                  width={width || undefined}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                />
              ))}
            </Document>
          )}
        </div>

        <div className="help-modal-footer">
          {onDisable ? (
            <button type="button" className="help-modal-disable" onClick={onDisable}>
              今後この画面では表示しない
            </button>
          ) : (
            <span />
          )}
          <button type="button" className="help-modal-ok" onClick={onClose}>閉じる</button>
        </div>
      </div>
    </div>
  );
}
